"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ListFilter = _interopRequireDefault(require("@/components/ListFilter"));
var _paginationEffect = _interopRequireDefault(require("@/utils/paginationEffect"));
var _ImmediateActivityDialog = _interopRequireDefault(require("./ImmediateActivityDialog.vue"));
var _sanjiang = require("@/api/sanjiang");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ImmediateActivity',
  components: {
    ListFilter: _ListFilter.default,
    ImmediateActivityDialog: _ImmediateActivityDialog.default
  },
  data: function data() {
    return _objectSpread({
      listLoading: false,
      tableData: {
        list: [],
        total: 0
      },
      tableFrom: {},
      dialogVisible: false,
      editData: null,
      buttonLoading: false,
      // 筛选配置
      FILTER_ITEMS: [{
        type: 'input',
        prop: 'activityName',
        label: '活动名称',
        attrs: {
          placeholder: '请输入活动名称',
          clearable: true
        }
      }, {
        type: 'select',
        prop: 'status',
        label: '活动状态',
        attrs: {
          placeholder: '请选择活动状态',
          clearable: true
        },
        options: [{
          label: '开启',
          value: 1
        }, {
          label: '关闭',
          value: 0
        }]
      }
      // {
      //   type: 'pickerRange',
      //   prop: 'activityTime',
      //   label: '活动时间',
      //   attrs: {
      //     placeholder: '活动开始日期 - 活动结束日期'
      //   }
      // }
      ]
    }, (0, _paginationEffect.default)(this.handlerGetListData));
  },
  created: function created() {
    this.handlerGetListData(this.pageData);
  },
  methods: {
    // 切换活动状态
    toggleActivityStatus: function () {
      var _toggleActivityStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        var newStatus, actionText, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              // 设置按钮加载状态
              this.$set(row, 'buttonLoading', true);
              newStatus = row.status; // el-switch已经自动切换了状态值
              actionText = newStatus === 1 ? '开启' : '关闭';
              _context.n = 1;
              return this.$confirm("\u786E\u5B9A".concat(actionText, "\u5F53\u524D\u6D3B\u52A8\u5417\uFF1F"), '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 1:
              _context.n = 2;
              return (0, _sanjiang.enableCloseImmediateActivity)(row.id, newStatus);
            case 2:
              this.$message.success("".concat(actionText, "\u6210\u529F"));

              // 刷新列表数据
              this.handlerGetListData();
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.handlerGetListData();
              if (_t !== 'cancel') {
                this.$message.error("".concat(row.status === 1 ? '关闭' : '开启', "\u5931\u8D25"));
                console.error('切换活动状态失败:', _t);
                // 如果操作失败，恢复原状态
                row.status = row.status === 1 ? 0 : 1;
              }
            case 4:
              _context.p = 4;
              // 清除按钮加载状态
              this.$set(row, 'buttonLoading', false);
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[0, 3, 4, 5]]);
      }));
      function toggleActivityStatus(_x) {
        return _toggleActivityStatus.apply(this, arguments);
      }
      return toggleActivityStatus;
    }(),
    // 新增活动
    addActivity: function addActivity() {
      var _this = this;
      this.buttonLoading = true;
      setTimeout(function () {
        _this.editData = null;
        _this.dialogVisible = true;
        _this.buttonLoading = false;
      }, 200);
    },
    // 编辑活动
    editActivity: function editActivity(row) {
      this.editData = row;
      this.dialogVisible = true;
    },
    // 查看详情
    // viewDetail(row) {
    //   this.$router.push({
    //     path: `/marketing/immediate/detail/${row.id}`
    //   });
    // },
    // 复制活动
    // copyActivity(row) {
    // },
    // 删除活动
    deleteActivity: function () {
      var _deleteActivity = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var loading, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return this.$confirm('确定删除当前活动吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 1:
              // 显示删除加载状态
              loading = this.$loading({
                lock: true,
                text: '正在删除...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context2.p = 2;
              _context2.n = 3;
              return (0, _sanjiang.deleteImmediateActivity)(row.id);
            case 3:
              this.$message.success('删除成功');
              this.handlerGetListData();
            case 4:
              _context2.p = 4;
              loading.close();
              return _context2.f(4);
            case 5:
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t2 = _context2.v;
              if (_t2 !== 'cancel') {
                this.$message.error('删除失败');
              }
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[2,, 4, 5], [0, 6]]);
      }));
      function deleteActivity(_x2) {
        return _deleteActivity.apply(this, arguments);
      }
      return deleteActivity;
    }(),
    // 弹框成功回调
    handleDialogSuccess: function handleDialogSuccess() {
      this.handlerGetListData();
    },
    // 关闭活动
    // closeActivity(row) {
    // },
    // 搜索处理
    handleSearch: function handleSearch(data) {
      if (data) {
        this.tableFrom = _objectSpread({}, data);
      } else {
        this.tableFrom = {};
      }
      this.resetPageData();
    },
    // 获取列表数据
    handlerGetListData: function () {
      var _handlerGetListData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var params, data, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.listLoading = true;
              params = _objectSpread(_objectSpread({}, this.tableFrom), this.pageData); // 处理时间范围
              if (params.activityTime && params.activityTime.length === 2) {
                params.startTime = params.activityTime[0];
                params.endTime = params.activityTime[1];
                delete params.activityTime;
              }

              // 处理活动名称参数映射
              if (params.activityName) {
                params.name = params.activityName;
                delete params.activityName;
              }
              _context3.p = 1;
              _context3.n = 2;
              return (0, _sanjiang.getImmediateActivityPage)(params);
            case 2:
              data = _context3.v;
              // 为每行数据添加buttonLoading属性
              if (data.list && data.list.length > 0) {
                data.list = data.list.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    buttonLoading: false
                  });
                });
              }
              this.tableData = data;
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              this.$message.error('获取数据失败');
              console.error('获取立减活动列表失败:', _t3);
              // 发生错误时清空表格数据
              this.tableData = {
                list: [],
                total: 0
              };
            case 4:
              _context3.p = 4;
              this.listLoading = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function handlerGetListData() {
        return _handlerGetListData.apply(this, arguments);
      }
      return handlerGetListData;
    }()
  }
};